/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index drawer-list to autogenerate all the fragments and extensions
 * Used by "prepareDrawerLists"
 */

import DrawerList from './drawer-list/DrawerList'
export * from './drawer-list/DrawerList'
export default DrawerList
